module.exports = __webpack_public_path__ + "static/media/wmsui32_3919.f790f686.ico";